export const CATEGORY_LABELS = { labour: 'Labour', material: 'Materials', fuel: 'Fuel', other: 'Other', plant: 'Plant' };
export const CATEGORY_ORDER = ['labour', 'material', 'fuel', 'other']; // Plant is legacy-only here (rolls into Plant & fuel on the ledger)
